var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatus = function SvgStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.39,
    y1: 144.39,
    x2: 200.89,
    y2: 6.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32.59,
    y1: 184.56,
    x2: 229.09,
    y2: 46.59,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,0C44.78,0,0,44.78,0,100c0,2.06.09,4.09.21,6.12l54.52-.23,18.71-73.39c.89-3.5,4.11-5.86,7.79-5.55,3.6.3,6.46,3.16,6.77,6.76l7.53,89.97,12.66-59.77c.68-3.24,3.43-5.62,6.74-5.86,3.27-.22,6.35,1.76,7.47,4.87l15.54,43.01,61.82.75c.15-2.2.25-4.43.25-6.68C200,44.78,155.23,0,100,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.75,115.78l-8.47-23.4-17.69,83.61c-.73,3.44-3.78,5.87-7.25,5.87-.16,0-.31-.01-.47-.01-3.67-.23-6.61-3.11-6.92-6.77l-8.05-96.23-9.24,36.24c-.84,3.27-3.77,5.57-7.16,5.58l-58.3.24c9.61,45.18,49.74,79.08,97.78,79.08s87.84-33.62,97.67-78.53l-65.04-.79c-3.09-.04-5.83-1.98-6.88-4.89Z"
  })));
};
export default SvgStatus;